const logos = [
  { src: '/images/logos/hikvision-2.png', alt: 'Hikvision' },
  { src: '/images/logos/zeker-vastgoedbeheer-1.png', alt: 'Zeker Vastgoedbeheer' },
  { src: '/images/logos/zdg-1.png', alt: 'ZDG' },
  { src: '/images/logos/los-en-stigter-1.png', alt: 'Los & Stigter' },
  { src: '/images/logos/yvey-1.png', alt: 'Yvey' },
  { src: '/images/logos/balkon-herstel-1.png', alt: 'Balkon Herstel' },
  { src: '/images/logos/vastgoed-unie-1.png', alt: 'Vastgoed Unie' },
  { src: '/images/logos/unnamed-1-1.png', alt: 'Opdrachtgever PuntUit' },
  { src: '/images/logos/Unknown-1.png', alt: 'Opdrachtgever PuntUit' },
  { src: '/images/logos/nhwonen-2.png', alt: 'NH Wonen' },
  { src: '/images/logos/konstrukt-group-1.png', alt: 'Konstrukt Group' },
  { src: '/images/logos/shared-logo-1.png', alt: 'Shared' },
  { src: '/images/logos/rotterdam-1.png', alt: 'Rotterdam' },
  { src: '/images/logos/bouwmeesters-2-1.png', alt: 'Bouwmeesters' },
  { src: '/images/logos/osapa-1.png', alt: 'Osapa' },
  { src: '/images/logos/zekerverduurzamen-1.png', alt: 'Zeker Verduurzamen' },
  { src: '/images/logos/kepler-1.png', alt: 'Kepler' },
  { src: '/images/logos/holland-opera.png', alt: 'Holland Opera' },
  { src: '/images/logos/hard-van-noord-holland-kopie-1.png', alt: 'Hart van Noord-Holland' },
  { src: '/images/logos/happy-hours-1.png', alt: 'Happy Hours' },
  { src: '/images/logos/Friends-to-Follow-PURPLE3-1.png', alt: 'Friends to Follow' },
  { src: '/images/logos/devries-kopie-1.png', alt: 'De Vries' },
  { src: '/images/logos/zeker-vastgoed-advies-1.png', alt: 'Zeker Vastgoed Advies' },
  { src: '/images/logos/de-heeren-van-zorg-1.png', alt: 'De Heeren van Zorg' },
  { src: '/images/logos/controlin-1.png', alt: 'Controlin' },
  { src: '/images/logos/alpha-society.png', alt: 'Alpha Society' },
];

export function LogoTicker() {
  const repeated = [...logos, ...logos, ...logos, ...logos];

  return (
    <section className="py-10 md:py-14 bg-white overflow-hidden" aria-labelledby="logo-ticker-title">
      <div className="container mb-6">
        <p id="logo-ticker-title" className="text-center text-xs font-semibold text-gray-400 uppercase tracking-[0.2em]">
          Vertrouwd door organisaties in heel Nederland
        </p>
      </div>

      <div className="logo-ticker" aria-label="Opdrachtgevers van PuntUit">
        <div className="logo-ticker-track">
          {repeated.map((logo, i) => (
            <div key={`${logo.src}-${i}`} className="logo-ticker-item">
              <img
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
                className="h-8 md:h-10 w-auto max-w-[150px] object-contain opacity-55 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
